import { Injectable } from '@angular/core';
import { UserDto } from '../../feature-modules/models/user-dto';

@Injectable()
export  class LoginMfaService{

    public deliveryDto: UserDto = new UserDto();

}